// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xIEe","colBig":"styles_colBig__1Iq8G","colSmall":"styles_colSmall__AlM2s"};